import React, { useEffect } from "react";
import clsx from "clsx";
import { useForm, Controller } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import PhoneInput from "react-phone-input-2";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from '@material-ui/core/Button';
import InfoIcon from '@material-ui/icons/Info';
import * as Yup from "yup";
import {
  Checkbox, Collapse, Paper,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  Grid,
  Divider,
  IconButton,
  CircularProgress
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import CloseIcon from "@material-ui/icons/Close";
import * as checkinActions from "src/actions/checkinActions";
import { Typography, TextField } from "@packages/ui";
import { theme } from "../ui/theme";
import { ThemeProvider } from "react-jss";
import getBrandfromUrl from "../../utils/getBrandFromUrl";
import getCountryFromURL from "../../utils/getCountryFromUrl";
import { enableInternationalOcrFlow } from "../../env";


function StyledCheckbox(props) {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ "aria-label": "decorative checkbox" }}
      {...props}
    />
  );
}

const AddDriverForm = ({ setCompletedQuestionaire, openUncompleteAddDriverAlert, setOpenUncompleteAddDriverAlert, defaultOpen }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [checked, setChecked] = React.useState({
    checkedYes: false,
    checkedNo: false,
  });

  const [confirmSend, setConfirmSend] = React.useState(false);
  const [smsSent, setSMSsent] = React.useState(false);
  const [openSMSFailAlert, setOpenSMSFailAlert] = React.useState(false);


  const checkin = useSelector((state) => state.checkin);


  // const handleChange = (event) => {
  //   setState({ ...state, [event.target.name]: event.target.checked });
  // };
  const handleCheckYes = (event) => {

    setChecked({ checkedNo: false, [event.target.name]: true });
    closeAlert();
  };
  const handleCheckNo = (event) => {

    setChecked({ checkedYes: false, [event.target.name]: true });
    closeAlert();


  };

  const closeAlert = () => {
    setOpenUncompleteAddDriverAlert(false);
  }

  useEffect(() => {
    if (checkin.additionalDriverIdVerified === true) {
      setChecked({ checkedYes: true, checkedNo: false });
      ;
    }
  }, [])

  useEffect(() => {
    if (checkin.smsInviteSentSuccess === false) {
      setOpenSMSFailAlert(true);
    }
  }, [checkin.smsInviteSentSuccess])

  useEffect(() => {
    if (checked.checkedNo || (checked.checkedYes && smsSent)
    ) {
      setCompletedQuestionaire(true);
    } else {
      setCompletedQuestionaire(false);

    }
  }, [smsSent, checked])


  const validationSchema = Yup.object().shape({
    additionalDriverMobileNumber: Yup.string()
      .required("Required")
      .max(15, "Contact Number must be less than 15 numbers ")
      .matches(
        /^[1-9]{1}[0-9]{7,11}$/,
        "Please Enter mobile number in countrycode followed by mobile number format"
      ),
    additionalDriverLastName: Yup.string()
      .required("Required")
      .max(25, "Last name should not be more than 25 characters"),
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      additionalDriverMobileNumber: "",
      additionalDriverLastName: "",
    },
  });

  const onSubmitAddDriver = (data) => {
    const mobileNumber = data.additionalDriverMobileNumber.trim();
    const lastName = data.additionalDriverLastName.trim();
    const bookingNumber = checkin.resNo;
    const brand = getBrandfromUrl();
    const country = getCountryFromURL();
    setConfirmSend(false);
    setOpenSMSFailAlert(false);

    dispatch(
      checkinActions.sendSMSInvite({
        mobileNumber,
        lastName,
        bookingNumber,
        brand,
        country,
        token: checkin.auth.token,

      })
    );
    console.log(mobileNumber, lastName);
    setSMSsent(true);

  };

  const onConfirm = () => {
    setConfirmSend(true);
  }

  return (
    <div style={{ textAlign: "start", marginLeft: "0rem" }}>
      <Collapse in={openUncompleteAddDriverAlert}>
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpenUncompleteAddDriverAlert(false);

              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {checked.checkedYes ? "Please fill in the additinal driver's details and click 'confirm'!" : 'Please complete the following question!'}
        </Alert>
      </Collapse>
      <ThemeProvider theme={theme}>
        <Typography className={classes.text} style={{ marginLeft: "0.5rem", marginBottom: "0.5rem" }} variant={"h4"}>
          Is there an additional driver{enableInternationalOcrFlow ? "" : " with Australian driver's licence"}?
      </Typography>

        {!defaultOpen && <>
          <StyledCheckbox checked={checked.checkedYes} onChange={handleCheckYes} name="checkedYes" />
          <Typography className={classes.text, classes.inlineText}>YES</Typography>

          <StyledCheckbox checked={checked.checkedNo} onChange={handleCheckNo} name="checkedNo" />
          <Typography className={classes.text, classes.inlineText}>NO</Typography>
        </>}

        <Collapse in={checked.checkedYes || defaultOpen}>
          {
            checkin?.additionalDriverIdVerified === true ? <Alert style={{ fontFamily: "Ride" }} icon={<InfoIcon fontSize="default" />} severity="success">
              Additional driver&apos;s ID has been verified successfully.
        </Alert> :
              checkin?.smsInviteSentSuccess === true ? <Alert style={{ fontFamily: "Ride" }} icon={<InfoIcon fontSize="default" />} severity="success">
                Text message sent to additional driver successfully.
          </Alert> :
                <form onSubmit={handleSubmit(onConfirm)}>
                  <Typography className={classes.text} style={{ marginLeft: "0.5rem", marginRight: "0.5rem" }} variant={"h6"}>
                    An additional driver surcharge fee may be applied at time of collection.
      </Typography>
                  <Collapse in={openSMSFailAlert}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setOpenSMSFailAlert(false);

                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {`\n ${checkin.smsInviteResMessage}`}
                      {'Please review and try again.'}<br />

                    </Alert>
                  </Collapse>

                  <Controller
                    control={control}
                    name="additionalDriverLastName"
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        fullWidth
                        label="Additional Driver's First Name"
                        id="additionalDriverLastName"
                        value={value}
                        onChange={e => { onChange(e); closeAlert() }}
                        error={errors.additionalDriverLastName ? true : false}
                        helperText={errors.additionalDriverLastName ? errors.additionalDriverLastName.message : null}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="additionalDriverMobileNumber"
                    render={({ field: { onChange, value } }) => (
                      <Paper component="form" className={classes.root2} elevation={0}>
                        <PhoneInput
                          value={value}
                          // onlyCountries={["au", "nz"]}
                          placeholder={"+61"}
                          country={"au"}
                          countryCodeEditable={true}
                          containerClass={classes.borderClass}
                          name="additionalDriverMobileNumber"
                          id="additionalDriverMobileNumber"
                          style={{marginBottom: '4px', marginTop: '4px'}}
                          buttonStyle={{
                            paddingTop:'18px'
                          }}
                          inputStyle={{ width: "100%", height: "100%", color: "#263238" }}
                          specialLabel={<span style={{ color: "rgb(84, 110, 122)" }}>Additional Driver&apos;s Mobile Number *</span>}
                          error={errors.additionalDriverMobileNumber ? true : false}
                          helperText={errors.additionalDriverMobileNumber ? errors.additionalDriverMobileNumber.message : null}
                          onChange={onChange}
                        />

                        <Divider className={classes.divider} orientation="vertical" />
                        {/* <Box style={{ margin: 15 }}>
                      <Button fullWidth loading={checkin.sendingSMS} type="submit" title={"Confirm"} />
                    </Box> */}
                        <Button size="large" variant="contained" color="primary" type="submit">
                          {checkin.sendingSMS ? <CircularProgress color="secondary" size={20} /> : "Confirm"}
                        </Button>


                      </Paper>

                    )}
                  />
                  {errors.additionalDriverMobileNumber && (
                    <p
                      style={{
                        color: "#f44336",
                        fontSize: "0.75rem",
                        marginLeft: "14px",
                        marginRight: "14px",
                      }}
                    >
                      {errors.additionalDriverMobileNumber.message}
                    </p>
                  )}


                </form>}

        </Collapse>

        <Dialog open={confirmSend}>
          <DialogContent>Once you have clicked &apos;confirm&apos;, the additonal driver will receive a text to verify their ID and other details.</DialogContent>
          <DialogActions>
            <Divider />
            <Grid spacing={1} container direction="row" justifyContent="center" alignItems="center">
              <Grid item xs={6} justifyContent="center">
                <Button style={{ marginLeft: "25%" }} color="primary" size="small" variant="contained" onClick={handleSubmit(onSubmitAddDriver)}>
                  CONFIRM
              </Button>
              </Grid>
              <Grid item xs={6} justifyContent="end">
                <Button style={{ marginLeft: "25%" }} color="primary" size="small" variant="contained" onClick={() => setConfirmSend(false)}>
                  Cancel
              </Button>
              </Grid>

            </Grid>
          </DialogActions>
        </Dialog>

      </ThemeProvider>

    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  borderClass: {
    "&.react-tel-input .form-control:focus": {
      borderColor: `${theme.palette.primary.main}`,
      boxShadow: "0px 0px 0px 1px #FFCC00",
    },
  },
  root2: {
    padding: '4px 0px',
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  text: {
    fontFamily: 'Ride',
  },
  inlineText: {
    display: "inline-block",
  },
  textError: {
    display: "inline-block",
    fontFamily: 'Ride',
    color: "#fc1100"
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: `${theme.palette.primary.white}`,
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
      border: `1px solid ${theme.palette.primary.darkergrey}`
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.ocean
    },
  },
  checkedIcon: {
    backgroundColor: `${theme.palette.primary.main}`,
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""'
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.ocean
    }
  },
}));

export default AddDriverForm;
